import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'trim',
    standalone: false
})
export class TrimPipe implements PipeTransform {
  transform(value: string, global = false): string {
    if (value === null) return value;

    if (global) value.replace(/\s/g, '');

    return value.trim();
  }
}
